import { getConfig } from '@hashnode/file-parsing'
import path from 'path'
import { ParsedConfig, configSchema } from '../schemas'

export function getGuideConfig(folderPath: string): ParsedConfig {
	const filePath = path.join(folderPath, 'config.ts')
	const configContent = getConfig({
		filePath,
	})

	if (!configContent) {
		throw new Error(`No config.ts file found in ${folderPath}`)
	}

	const parsedSettings = configSchema.parse(configContent)
	return parsedSettings
}
